import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { KeyLockersQueryKeys } from "modules/KeyLockersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeactivateKeyLockerBoxMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async keylocker_box_id => {
      await ApiInstance.post("/dashboard/box/disable", { keylocker_box_id }, ENV.keylockerBaseURL);
    },
    onSuccess: keylocker_box_id => {
      const keyLockerBoxes = typedQueryClient.getQueryData(KeyLockersQueryKeys.keyLockerDetails);
      if (!keyLockerBoxes) return;

      const keyLockerBoxIdx = keyLockerBoxes.findIndex(keyLockerBox => keyLockerBox.id === keylocker_box_id);
      if (keyLockerBoxIdx === -1) return;

      typedQueryClient.setQueryData(KeyLockersQueryKeys.keyLockerDetails, keyLockerBoxes.with(keyLockerBoxIdx, { ...keyLockerBoxes[keyLockerBoxIdx], active: false }));
    }
  });
